// components/SEO.jsx
import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  keywords,
  url,
  image = "https://bestcodetechnology.in/og-image.png",
}) => {
  return (
    <Helmet>
      {/* PRIMARY */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* ROBOTS */}
      <meta name="robots" content="index, follow" />

      {/* CANONICAL */}
      <link rel="canonical" href={url} />

      {/* OPEN GRAPH */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* TWITTER */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* MOBILE */}
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta
        name="google-site-verification"
        content="F-zsZpNP-IS1lQW-RYvk0EtotmWxuFjWBwMoRsLa1mE"
      />
    </Helmet>
  );
};

export default SEO;
